import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tabs-header" }
const _hoisted_2 = ["onClick"]

import { computed, onMounted, ref, useSlots, VNode, watch } from 'vue';
import { TabProps } from './tab/CustomTab.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomTabs',
  props: {
    modelValue: { default: '' },
    tabClass: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeTab = ref<string | number>('');

const slots = useSlots();

const tabs = computed<VNode[]>(() => {
  return slots.default ? slots.default() : [];
});

const tabsMeta = computed<TabProps[]>(() => {
  return tabs.value.map((tabVNode) => {
    return tabVNode.props as TabProps;
  });
});

onMounted(() => {
  if (tabsMeta.value.length) {
    const initial = props.modelValue;
    const exists = tabsMeta.value.some((meta) => meta.id === initial);
    if (exists) {
      activeTab.value = initial;
    } else {
      activeTab.value = tabsMeta.value[0].id;
      emit('update:modelValue', activeTab.value);
    }
  }
});

watch(
  () => props.modelValue,
  (newValue) => {
    const exists = tabsMeta.value.some((meta) => meta.id === newValue);
    if (exists) {
      activeTab.value = newValue;
    }
  }
);

function selectTab(id: string | number): void {
  activeTab.value = id;
  emit('update:modelValue', id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabsMeta.value, (meta) => {
        return (_openBlock(), _createElementBlock("li", {
          key: meta.id,
          class: _normalizeClass({ active: activeTab.value === meta.id, disabled: meta.disabled }),
          onClick: ($event: any) => (!meta.disabled && selectTab(meta.id))
        }, _toDisplayString(meta.title), 11, _hoisted_2))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tabVNode) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: tabVNode.props!.id,
        class: _normalizeClass([_ctx.tabClass, "tab-grow"])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(tabVNode)))
      ], 2)), [
        [_vShow, activeTab.value === tabVNode.props!.id]
      ])
    }), 128))
  ], 64))
}
}

})